import { auth } from '../services/firebase';

/**
 * Fetch wrapper that automatically adds Firebase auth token
 */
export async function authFetch(url, options = {}) {
  try {
    // Get current user and token
    const user = auth.currentUser;
    
    if (user) {
      const token = await user.getIdToken();
      
      // Add Authorization header
      options.headers = {
        ...options.headers,
        'Authorization': `Bearer ${token}`
      };
    }

    // Make the fetch request
    const response = await fetch(url, options);
    return response;
  } catch (error) {
    console.error('Auth fetch error:', error);
    throw error;
  }
}

/**
 * Convenience methods
 */
export const apiClient = {
  get: async (url, options = {}) => {
    return authFetch(url, { ...options, method: 'GET' });
  },
  
  post: async (url, data, options = {}) => {
    return authFetch(url, {
      ...options,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      body: JSON.stringify(data)
    });
  },
  
  put: async (url, data, options = {}) => {
    return authFetch(url, {
      ...options,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      body: JSON.stringify(data)
    });
  },
  
  delete: async (url, options = {}) => {
    return authFetch(url, { ...options, method: 'DELETE' });
  },
  
  // For file uploads (multipart/form-data)
  upload: async (url, formData, options = {}) => {
    return authFetch(url, {
      ...options,
      method: 'POST',
      body: formData
      // Don't set Content-Type - browser will set it with boundary
    });
  }
};
